import './bootstrap';
import './floating-ui';

import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.start();

